// Mock data for doctor portfolio prototype

export const doctorInfo = {
  name: "Dr. Raja Srivastav",
  designation: "MD, Transplant Pulmonologist",
  specialty: "Transplant Pulmonology",
  tagline: "Compassionate Care, Life-Saving Expertise",
  heroImage: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d",
  aboutImage: "https://images.unsplash.com/photo-1612531385446-f7e6d131e1d0",
  email: "dr.raja@lilavathihospital.com",
  phone: "+91 98765 43210",
  address: "Lilavathi Hospital, Hyderabad, Telangana - 500001",
  locationEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.274!2d78.4867!3d17.3850!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99c7459e5c23%3A0x6a3b1c2b3c4d5e6f!2sLilavathi%20Hospital!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
  yearsOfExperience: 18,
  patientsServed: "2000+",
  successRate: "95%",
};

export const aboutDoctor = {
  bio: "Dr. Raja Srivastav is a renowned transplant pulmonologist with over 18 years of experience in lung transplantation and advanced respiratory care. He specializes in complex lung transplant procedures and has been instrumental in bringing hope to patients with end-stage lung diseases across Telangana and Andhra Pradesh.",
  philosophy:
    "I am committed to providing patient-centered care with compassion and excellence. My approach integrates cutting-edge medical technology with traditional values of empathy and dedication, ensuring every patient receives the best possible treatment for their respiratory health.",
  highlights: [
    "Specialist in Lung Transplantation",
    "18+ years of clinical experience",
    "Recognized for successful transplant outcomes",
    "Active member of Indian Medical Association",
  ],
};

export const specialties = [
  {
    id: 1,
    title: "Lung Transplantation",
    description: "Expert surgical procedures for end-stage lung diseases",
    icon: "Shield",
  },
  {
    id: 2,
    title: "Advanced Respiratory Care",
    description: "Comprehensive treatment for complex pulmonary conditions",
    icon: "Heart",
  },
  {
    id: 3,
    title: "Interstitial Lung Disease",
    description:
      "Specialized care for fibrotic and inflammatory lung conditions",
    icon: "User",
  },
  {
    id: 4,
    title: "Critical Care Pulmonology",
    description: "Intensive care management for severe respiratory illnesses",
    icon: "Users",
  },
];

export const services = [
  {
    id: 1,
    title: "Lung Transplant Evaluation",
    description:
      "Comprehensive assessment and preparation for lung transplantation",
    image: "https://images.unsplash.com/photo-1739285388427-d6f85d12a8fc",
  },
  {
    id: 2,
    title: "Post-Transplant Care",
    description: "Ongoing monitoring and management after lung transplantation",
    image: "https://images.pexels.com/photos/4226119/pexels-photo-4226119.jpeg",
  },
  {
    id: 3,
    title: "Advanced Bronchoscopy",
    description: "Minimally invasive diagnostic and therapeutic procedures",
    image: "https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg",
  },
  {
    id: 4,
    title: "Respiratory Rehabilitation",
    description: "Comprehensive pulmonary rehabilitation programs",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f",
  },
];

export const experience = [
  {
    id: 1,
    year: "2010 - Present",
    title: "Senior Transplant Pulmonologist",
    organization: "Lilavathi Hospital, Hyderabad",
    description:
      "Leading lung transplant program and advanced respiratory care services",
  },
  {
    id: 2,
    year: "2007 - 2010",
    title: "Pulmonology Consultant",
    organization: "Apollo Hospitals, Vijayawada",
    description:
      "Established respiratory care unit and performed complex procedures",
  },
  {
    id: 3,
    year: "2004 - 2007",
    title: "Pulmonology Fellow",
    organization: "NIMS Hospital, Hyderabad",
    description:
      "Advanced training in interventional pulmonology and transplant medicine",
  },
  {
    id: 4,
    year: "2000 - 2004",
    title: "MBBS & MD Training",
    organization: "Osmania Medical College, Hyderabad",
    description: "Medical education and specialization in pulmonary medicine",
  },
];

export const certifications = [
  {
    id: 1,
    title: "Medical Registration",
    organization: "Telangana State Medical Council",
    year: "2004 - Present",
  },
  {
    id: 2,
    title: "DM in Pulmonary Medicine",
    organization: "National Board of Examinations, India",
    year: "2007",
  },
  {
    id: 3,
    title: "Fellowship in Transplant Pulmonology",
    organization: "Indian Society of Organ Transplantation",
    year: "2010",
  },
  {
    id: 4,
    title: "Advanced Life Support Certification",
    organization: "Indian Resuscitation Council",
    year: "2023",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    text: "Dr. Srivastav gave me a new lease on life through lung transplantation. His expertise and compassionate care made all the difference. I am forever grateful.",
    date: "January 2024",
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    text: "The best pulmonologist in Hyderabad! Dr. Srivastav's thorough approach and dedication to patient care is exceptional. Highly recommend for respiratory issues.",
    date: "December 2023",
  },
  {
    id: 3,
    name: "Venkat Reddy",
    rating: 5,
    text: "Dr. Srivastav successfully managed my complex lung condition. His knowledge and the team's support have significantly improved my quality of life.",
    date: "November 2023",
  },
  {
    id: 4,
    name: "Anjali Patel",
    rating: 5,
    text: "Professional, caring, and always available. Dr. Srivastav goes above and beyond for his patients. I'm grateful to have him as my doctor.",
    date: "October 2023",
  },
];

export const publications = [
  {
    id: 1,
    title: "Outcomes of Lung Transplantation in South Indian Population",
    journal: "Indian Journal of Chest Diseases & Allied Sciences",
    year: "2023",
    authors: "Srivastav, R., Kumar, A., et al.",
  },
  {
    id: 2,
    title:
      "Advances in Interventional Pulmonology: Experience from Tertiary Care Centers",
    journal: "Journal of Association of Physicians of India",
    year: "2022",
    authors: "Srivastav, R., Reddy, S.",
  },
  {
    id: 3,
    title: "Post-Transplant Management of Pulmonary Complications",
    journal: "Indian Journal of Transplantation",
    year: "2021",
    authors: "Srivastav, R., et al.",
  },
  {
    id: 4,
    title: "Bronchoscopic Interventions in Complex Airway Diseases",
    journal: "Lung India",
    year: "2020",
    authors: "Srivastav, R., Sharma, M.",
  },
];

export const gallery = [
  {
    id: 1,
    image:
      "https://images.pexels.com/photos/35260725/pexels-photo-35260725.jpeg",
    title: "Modern Clinic Facility",
    category: "Facility",
  },
  {
    id: 2,
    image: "https://images.pexels.com/photos/236380/pexels-photo-236380.jpeg",
    title: "Patient Care Room",
    category: "Facility",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1739285388427-d6f85d12a8fc",
    title: "Patient Consultation",
    category: "Services",
  },
  {
    id: 4,
    image: "https://images.pexels.com/photos/4226119/pexels-photo-4226119.jpeg",
    title: "Diagnostic Services",
    category: "Services",
  },
  {
    id: 5,
    image: "https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg",
    title: "Healthcare Team",
    category: "Team",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f",
    title: "Medical Professional",
    category: "Team",
  },
];
